import React, { useEffect, useState } from "react";
import { Modal, Button } from "rsuite";
import financeWebinarImg from "../../assets/images/finance-webinar-modal.jpeg";
import "./index.css";

const FinanceWebinarModal = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (window.location.pathname === "/finance-webinar") {
      return;
    }

    // Check localStorage to see if modal should be shown
    const lastShown = localStorage.getItem("financeWebinarModalLastShown");
    const modalClosed = localStorage.getItem("financeWebinarModalClosed");

    const currentDate = new Date().toDateString();

    // If user closed it today, don't show
    if (lastShown === currentDate && modalClosed === "true") {
      return;
    }

    // Set timer to show modal after 5 seconds
    const timer = setTimeout(() => {
      setShowModal(true);
      localStorage.setItem("financeWebinarModalLastShown", currentDate);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShowModal(false);
    localStorage.setItem("financeWebinarModalClosed", "true");
  };

  const handleRegister = () => {
    window.location.href = "/finance-webinar";
  };

  const handleModalClick = (e) => {
    // Prevent clicks on buttons from triggering navigation
    if (
      !e.target.closest("button") &&
      !e.target.closest(".rs-modal-header-close")
    ) {
      window.location.href = "/finance-webinar";
    }
  };

  return (
    <Modal
      open={showModal}
      onClose={handleClose}
      backdrop="static"
      className="finance-webinar-modal"
      onClick={handleModalClick}
    >
      <Modal.Header>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="modal-content">
          <img
            src={financeWebinarImg}
            alt="Finance Webinar"
            className="webinar-image-finance"
            onClick={() => {
              window.location.href = "/finance-webinar";
            }}
          />
          <div className="modal-actions">
            <Button appearance="primary" onClick={handleRegister}>
              Register Now
            </Button>
            <Button appearance="subtle" onClick={handleClose}>
              Close
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default FinanceWebinarModal;
